import CustomModal from '../../../components/Modal/CustomModal';
import { CustomSelect } from '../../../components/CustomSelect';
import FunctionalityAddGraphModal from './../Functionality/AddGraph';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AddGraphModal = ({ show, onHide, chartComponents, userId, sectionPosition, dashboardIdSection }) => {
    const { t } = useTranslation();
    const {
        handleCreate,
        isCreateButtonDisabled,
        selectedChartType,
        handleChartTypeChange,
        selectedGraph,
        handleGraphChange,
        availableCharts,
        emptyFields,
        setEmptyFields,
    } = FunctionalityAddGraphModal({
        dashboardIdSection,
        sectionPosition,
        userId,
        onHide,
        t,
    });
    return (
        <CustomModal
            title='create'
            size='lg'
            onHide={onHide}
            onConfirm={() => {
                if (selectedChartType !== '' && selectedGraph !== '') {
                    handleCreate();
                } else {
                    setEmptyFields(true);
                    toast.warn(t('please_fill_all_fields'));
                }
            }}
            buttonConfirm='confirm'
            buttonCancelText='cancel'
            cancelButton={true}
            confirmButton={true}
            show={show}
            classNameBody="pt-2"
        >
            <h5 className='label-graph'>{t('choose_a_data')}</h5>
            <div className='mt-3'>
                <CustomSelect
                    id='slt_agm_data'
                    value={selectedChartType}
                    onChange={handleChartTypeChange}
                    list={Object.entries(chartComponents).map(([key, value]) => ({
                        id: key,
                        name: value,
                    }))}
                    trans='data'
                    key={`chartType-${emptyFields}`}
                    keyName='id'
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <CustomSelect
                id='slt_agm_graph'
                value={selectedGraph}
                onChange={(e) => handleGraphChange(e.target.value)}
                list={availableCharts.map((chart) => ({
                    id: chart.id,
                    name: chart.title,
                }))}
                trans='graph'
                key={`graph-${emptyFields}`}
                keyName='id'
                emptyFields={emptyFields}
                required={true}
            />
        </CustomModal>
    );
};

export default AddGraphModal;
